import { defineStore } from 'pinia'
import { storage } from '@/utils/storage'
import i18n from '@/locales/index';
import { usePlatform, useCacheData } from "@/hooks";
import MyDialog from '@/plugins/component/MyDialog';
import { queryConfig, queryAppVersion, queryDepositProduct, queryLuckySpinAward } from '@/api';

const { localCache } = useCacheData();

export const useSettingsStore = defineStore('settings', {
  state: () => {
    return {
      isSound: storage.get('isSound', false), // 提示音
      isMusic: storage.get('isMusic', false), // 背景音乐
      csFacebook: '',
      csTelegram: '',
      csOnline: '',
      psFacebook: '',
      psTelegram: '',
      psOnline: '',
      downloadPage: '',
      deviceId: '',
      version: '',
      versionCode: '',
      registerCode: storage.get('registerCode', ''), // 注册邀请码
      depositProduct: null, //充值渠道
      luckySpinRewards: null, // 大转盘 转盘奖励列表
      canPWA: false, // pwa安装是否已准备
      showIOSWebApp: false, //是否显示IOS Web App下载
      showDownloadBanner: false, //是否显示首页下载广告
      showTopTip: false,
    }
  },
  getters: {
    downloadUrl: state => {
      let baseUrl = new URL(state.downloadPage);
      baseUrl.searchParams.append("code", state.registerCode);
      return baseUrl.toString();
    },
  },
  actions: {
    set(key, value = true) {
      this[key] = value;
    },
    initShowSetting() {
      const { isIOS, isAndroid, isStandalone, isChrome, canCallChrome } = usePlatform()
      if (window.$bridge || isStandalone) {
      } else if (isIOS) {
        this.showIOSWebApp = true;
      } else {
        this.showDownloadBanner = true;
        // this.showTopTip = isAndroid && !isChrome;
        if (isAndroid && !isChrome && canCallChrome) {
          const protocol = window.location.protocol.replace(':', '');
          // 使用更可靠的intent协议
          const intentUrl = `intent://${window.location.host}${window.location.pathname}${window.location.search}#Intent;scheme=${protocol};package=com.android.chrome;end`;
          // 尝试通过location.href跳转
          window.location.href = intentUrl;
        }
      }
    },
    initConfig() {
      return localCache({ 
        cacheKey: 'config', 
        dataApi: queryConfig,
        defaultData: {},
        dataProcessing: config => {
          this.csFacebook = config['cs_facebook'];
          this.csTelegram = config['cs_telegram'];
          this.csOnline = config['cs_online'];
          this.psFacebook = config['ps_facebook'];
          this.psTelegram = config['ps_telegram'];
          this.psOnline = config['ps_online'];
          this.downloadPage = config['download_page'];
        }
      });
    },
    initLuckySpinAward() {
      return localCache({ 
        cacheKey: 'luckySpinAward',
        defaultData: [],
        dataApi: queryLuckySpinAward,
        dataProcessing: data => {
          this.luckySpinRewards = data
        }
      });
    },
    fetchDepositProduct(callback) {
      // 增加 retrun 为了在main.js中可以使用 Promise.all 等待请求完成
      return queryDepositProduct().then(res => {
        this.depositProduct = res.data || [];
        callback && callback();
      })
    },
    initDeviceInfo() {
      if (window.$bridge) {
        window.$bridge.callHandler('getDeviceInfo', '', result => {
          let data = JSON.parse(result);
          this.deviceId = data.deviceId;
          this.version = data.versionName;
          this.versionCode = data.versionCode;
        });
      }
    },
    checkAppVersion() {
      if (window.$bridge) {
        queryAppVersion().then(res => {
          let { versionCode, downloadUrl } = res.data || {}
          if (!this.versionCode || this.versionCode < versionCode) {
            MyDialog.confirm({
              message: i18n.global.t('msg.versionUpdate'),
            })
            .then(() => {// on confirm
              window.$bridge.callHandler('openBrowser', downloadUrl)
            })
            .catch(() => {});
          }
        })
      }
    },
    setRegisterCode(code) {
      this.registerCode = code;
      storage.set('registerCode', code, null);
    },
    setSound(value) {
      this.isSound = value
      storage.set('isSound', value, null)
    },
    setMusic(value) {
      this.isMusic = value
      storage.set('isMusic', value, null)
    },
    hideIOSWebApp() {
      this.showIOSWebApp = false;
    },
    hideDownloadBanner() {
      this.showDownloadBanner = false;
    },
    hideTopTip() {
      this.showTopTip = false;
    },
  }
})
